import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';
import { COMPANY_STATUS_NEW, nameValidation2, renderField } from '../../../common';

let Edit = props => {
  const { handleSubmit } = props;
  return (
    <form className="ScForm" onSubmit={handleSubmit}>
      <div>
        <h2>Ред. компанию</h2>
        <div>
          <label>Название*</label>
          <Field
            name="name"
            data-lpignore
            autoComplete="off"
            component={renderField}
            validate={nameValidation2}
            type="text"
            placeholder=""
          />
        </div>
      </div>
      <div>
        <label>Статус</label>
        <Field name="statusnew" component="select">
          {COMPANY_STATUS_NEW.map(({ id, name, color }) => <option key={id} value={id} style={{ color: color }}>{name}</option>)}
        </Field>
      </div>
      <div>
        <label>Город</label>
        <Field name="cityId" component="select">
          {props.city.map(({ id, title }) => <option key={id} value={id}>{title}</option>)}
        </Field>
      </div>
      <div>
        <label>Адрес</label>
        <Field name="address_details" component="input" type="text" placeholder="" />
      </div>
      <div>
        <label>Стоимость лида</label>
        <Field name="leadCost" component="input" type="text" placeholder="" />
      </div>

      <div>
        <label>Выпл. Оператору</label>
        <Field name="operator_fee" component="input" type="text" placeholder="" />
      </div>

      <div>
        <label>Выпл. Руководителю</label>
        <Field name="chief_fee" component="input" type="text" placeholder="" />
      </div>

      <div>
        <label>Выпл. Директору</label>
        <Field name="director_fee" component="input" type="text" placeholder="" />
      </div>

      <div>
        <label>Имя руководителя</label>
        <Field name="manager_name" component="input" type="text" placeholder="" />
      </div>

      <div>
        <label>Контакт руководителя</label>
        <Field name="manager_contact" component="input" type="text" placeholder="" />
      </div>

      <div>
        <label>Тематики</label>
        <Field name="subjects" component="input" type="text" placeholder="" />
      </div>
      <div>
        <button type="submit">
            Редактировать компанию
        </button>
      </div>
    </form>
  );
};

Edit = reduxForm({
  form: 'editCompany'
})(Edit);

Edit = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving,
  city: state.sc.city
}))(Edit);

export default Edit;



// WEBPACK FOOTER //
// ./src/pages/callcenter/company/Edit.js